export default class LocalStorageKeys {
  static PREFERRED_LANG = "preferredLang";

  static DOWNLOAD_APP_PROMPT = "downloadAppPrompt";

  static SELECTED_BUSINESS = "selectedBusiness";

  static EXCLUDED_INTROS = "excludedIntros";

  static ABRA_FLEXI_BEE_SETTINGS = "abraFlexiBeeSettings";

  static LAST_ASKED_BUSINESS_EMAIL = "lastAskedBusinessEmail";

  static AUDIT_FILTERS = "auditFilters";

  static TASKS_VIEW_LAST_TAB = "tasksViewLastTab";
}
